import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading';
import Input from '../form/inputs/Input';
import InputPesel from '../form/inputs/InputPesel';
import InputDowod from '../form/inputs/InputDocument';
import InputCalendar from '../form/inputs/inputCalendar';
import Button from '../buttons/Button';
import Select from '../form/selects/Select';
import Radio from '../form/radio/Radio';
import maritalStatuses from './../../static-data/marital-status.json'
import documents from './../../static-data/documents.json'
import countries from './../../static-data/countries.json';
import citizenship from './../../static-data/citizenship.json';
import SelectsWritable from './../form/selects/SelectsWritable';
import "moment/locale/pl";
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import CheckboxRadio from '../form/checkbox/CheckboxRadio';
import Text from '../text/Text';
import ButtonsNav from './../buttons-nav/ButtonsNav';
import Checkbox from './../form/checkbox/Checkbox';

const AuthorizedPersons = ( props ) => {
    let [ load, setLoad ]                           = useState(false);   
    let [ isOpenFirst, setIsOpenFirst ]             = useState([]);   
    let [ isOpenSecond, setIsOpenSecond ]           = useState([]); 
    let [ forceValidateNip, setForceValidateNip ]   = useState(false);
    let [ forceValidate, setForceValidate ]         = useState(false);
    let [ updateArray, setUpdateArray ]             = useState(0);
    const dispatch        = useDispatch()
    let registryType           = useSelector(state => state.registryType)
    let authorizedPersons      = useSelector(state => state.authorizedPersons)
    let dataFromGUS          = useSelector(state => state.dataFromGUS)
    let productPrice                      = useSelector(state => state.productPrice)

    useEffect(() => {
      if( !load ) {
        if ( dataFromGUS.fiz_imie1 ) {
            updateValue(dataFromGUS.fiz_imie1, 0, 'name')
        }
        if ( dataFromGUS.fiz_imie1 ) {
            updateValue(dataFromGUS.fiz_nazwisko, 0, 'surname')
        }
        setLoad(true);
      }
    }, [load])

    // useEffect(() => {
    //     if( !load ) {
    //       if ( dataFromGUS.fiz_imie1 && authorizedPersons[0]?.name != dataFromGUS.fiz_imie1 ) {
    //           updateValue(dataFromGUS.fiz_imie1, 0, 'name')
    //       }
    //       setLoad(true);
    //     }
    //   }, [load, dataFromGUS, authorizedPersons])
    
    
    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
      }
    
    let prev = () => {
        props.prev();
    }
    let next = async () => {
        await setForceValidate(true)
        await wait(100);
        let errors = await checkErrors();
        await wait(100);
        await setForceValidate(false)


        if ( !errors ) {
            props.next();
        };
    }

    //update local array
    let updateValue =  async( val, index, property ) => {
        let copyArray = authorizedPersons;
        copyArray[index][property] = val;
        dispatch({ type: 'AUTHORIZED_PERSONS_CHANGE', value: copyArray })
        await setUpdateArray(++updateArray);
    }

    let addItemToArray = async() => {
        await setForceValidate(true);
        await wait(10);
        let errors = await checkErrors();
        if ( !errors ) {
            await setForceValidate(false);

            let el = {
                name: '',
                surname: '',
                dateOfBirth: '',
                document: '',
                citizenship: '',
                email: '',
                phone: '',
                id: ''
            };
            let copy = [ ...authorizedPersons, el ];
            dispatch({ type: 'AUTHORIZED_PERSONS_CHANGE', value: copy })
        } 
    }
    let checkErrors = () => {
        let result;
        let elements = document.querySelectorAll('.error-item');
        if( elements.length > 0 ) {
            result = true;
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: elements[0].offsetTop - 185
            });
        } else {
            result = false;
        }
        return result;
        
    }

    let removeLastFromArray = async () => {
        let copyArray = authorizedPersons;
        await copyArray.splice(-1, 1);
        await dispatch({ type: 'AUTHORIZED_PERSONS_CHANGE', value: copyArray })
        await setUpdateArray(++updateArray);
    }
    
    const updateCalendar = (type, index, status) => {
        let newRes = [];
        if(status) {
            if(type == "first") {
                if(!isOpenFirst.includes(index)) {
                    setIsOpenFirst([...isOpenFirst, index]);
                }
            }else if(type == "second") {
                if(!isOpenSecond.includes(index)) {
                    setIsOpenSecond([...isOpenSecond, index]);
                }
            }
        }else{
            if(type == "first") {
                if(isOpenFirst.includes(index)) {
                    newRes = isOpenFirst.filter(first => first == index ? null : first)
                    setIsOpenFirst(newRes);
                }
            }else if(type == "second") {
                if(isOpenSecond.includes(index)) {
                    newRes = isOpenSecond.filter(second => second == index ? null : second)
                    setIsOpenSecond(newRes);
                }
            }
        }
    }

    const checkExpirationDate = (date, index) => {
        let val = moment(date, "YYYY-MM-DD");
        val = val.add(10, 'years').format('YYYY-MM-DD');
        if ( authorizedPersons[index].document != "Inny (np. karta pobytu)" ) {
            updateValue(val, index, 'idExpirationDate');
        }
    }

    const checkReleaseDate = (date, index) => {
        let val = moment(date, "YYYY-MM-DD");
        val = val.subtract(10, 'years').format('YYYY-MM-DD');
        if ( authorizedPersons[index].document != "Inny (np. karta pobytu)" ) {
            if(authorizedPersons[index].document == "Dowód osobisty") {
                let dateNotUpdateRelease = moment("2021.08.02", "YYYY-MM-DD");
                let fromDate = moment(date, "YYYY-MM-DD");

                if(fromDate.isSameOrAfter(dateNotUpdateRelease)) {
                    // console.log('nie ma zakresu');
                }else{
                    updateValue(val, index, 'idReleaseDate');
                }
            }else{
                updateValue(val, index, 'idReleaseDate');
            }
        }
    }

    const getPlaceholderByDocument = document => {
        switch (document) {
            case 'Dowód osobisty':
                return  { 
                    serie: "Seria i numer dowodu osobistego",
                    dateStart: "Data wydania dowodu osobistego",
                    dateEnd: "Data ważności dowodu osobistego",
                };

            case 'Paszport':
                return  { 
                    serie: "Seria i numer paszportu",
                    dateStart: "Data wydania paszportu",
                    dateEnd: "Data ważności paszportu",
                };

            case 'Inny (np. karta pobytu)':
                return  { 
                    serie: "Seria i numer dokumentu",
                    dateStart: "Data wydania dokumentu",
                    dateEnd: "Data ważności dokumentu",
                };
            default:
                break;
        }
    }

    const getRegExpByDocument = document => {

        switch (document) {
            case 'Dowód osobisty':
                return /^.{5,15}$/;

            case 'Paszport':
                return  /^[A-z]{2}[0-9]{7}$/

            case 'Seria i numer dokumentu':
                return /^.{5,15}$/;
            default:
                break;
        }
        
    }

    const changeTypeReset = ( val, i ) => {
        if ( load && authorizedPersons.length > 0 ) {
            if ( val == authorizedPersons[i].document || authorizedPersons[i].document == '' ) {
                return false;
            } else {
                updateValue(null, i, 'idExpirationDate');
                updateValue(null, i, 'idReleaseDate');
                setUpdateArray(++updateArray)
            }
            
        }
    }

    const toggleNext = ( val, index ) => {
        if(val) {
            addItemToArray(index);
        }else{
            removeLastFromArray(index);
        }
    }

    return (
        <div className="customer-information authorized">
            <div className="container">
                <Heading title="Agreement authorizations"
                        borderBottom 
                        tip={ false } 
                        tipHeader="Liczba pracowników"
                        tipText="Wpisz łączną liczbę pracowników, niezależnie od formy zatrudnienia. W przypadku działalności jednoosobowej bez osób zatrudnionych, wpisz 0." />
                <Heading title="People authorized to sign the agreement"
                        medium
                        borderBottomDotted 
                        tip={ false } 
                        tipHeader="Liczba pracowników"
                        tipText="Wpisz łączną liczbę pracowników, niezależnie od formy zatrudnienia. W przypadku działalności jednoosobowej bez osób zatrudnionych, wpisz 0." />
                { updateArray >= 0 && authorizedPersons && authorizedPersons.map( ( item, index ) => (
                    <>
                    <div className="input-row">
                        <div className="col">
                            <Input  name={"name-"+index}
                                    id={"name-"+index}
                                    required={ true }
                                    setFunction={ val => { updateValue(val, index, 'name'); } }
                                    type="text"
                                    label={ "Name" }
                                    placeholder={ "Name" }
                                    val={ item.name }
                                    size="full" 
                                    regExp={/.*/}
                                    allowChars={/.*/}
                                    minChar={ 1 } 
                                    forceValidate={ forceValidate } />
                        </div>
                        <div className="col">
                            <Input  name={"surname-"+index}
                                    id={"surname-"+index}
                                    required={ true }
                                    setFunction={ val => { updateValue(val, index, 'surname'); } }
                                    type="text"
                                    label={ "Surname" }
                                    placeholder={ "Surname" }
                                    val={ item.surname }
                                    size="full" 
                                    regExp={/.*/}
                                    allowChars={/.*/}
                                    minChar={ 0 } 
                                    forceValidate={ forceValidate } />
                        </div>
                    </div>
                    <div className="input-row">
                        <div className="col">
                            <InputCalendar  name={"date-of-birth-"+index}
                                id={"date-of-birth-"+index}
                                required={ true }
                                setFunction={ val => { updateValue(val, index, 'dateOfBirth') } }
                                // openCalendar={ () => updateCalendar("second", index, true) }
                                type="text"
                                label="Date of birth"
                                placeholder="Date of birth"
                                // placehold={  getPlaceholderByDocument( item.document ).dateEnd }
                                val={ item.dateOfBirth }
                                size="full" 
                                openCalendar={() => console.log('click')}
                                calendar={ true }
                                regExp={/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/}
                                allowChars={/^[0-9-]{0,10}$/}
                                minChar={ 1 } 
                                maxDate={new Date()}
                                forceValidate={ forceValidate } />
                        </div>
                        <div className="col">
                            <InputDowod  name={"id-"+index}
                                id={"id-"+index}
                                required={ true }
                                setFunction={ val => { updateValue(val, index, 'id'); } }
                                type="text"
                                label={ "Passport number" }
                                placeholder={  "Enter the 12-letter/digits no." }
                                val={ item.id }
                                size="full" 
                                regExp={ /^[A-Za-z]{2}[0-9]{10}$/ }
                                allowChars={/^.{0,12}$/}
                                minChar={ 0 } 
                                forceValidate={ forceValidate } />
                        </div>
                    </div>
                    <div className="input-row">
                        <div className="col">
                            <SelectsWritable
                                id={`citizenship-${index}`}
                                required={ false }
                                data={ citizenship && citizenship.filter(c => c.name != item.citizenship) } 
                                forceValidate={ forceValidate } 
                                val={ item.citizenship }
                                label="Nationality" 
                                placeholder="Nationality" 
                                setFunction={ (val) => updateValue(val, index, 'citizenship') } />
                        </div>
                        <div className="col">
                            <Input  id={"phone-" + index }
                                    name={"phone-" + index }
                                    required={ true }
                                    setFunction={ val => { updateValue(val, index, 'phone'); } }
                                    type="text"
                                    // label={ "Mobile number" }
                                    label={ "Registered mobile number with UAE Pass" }
                                    placeholder={ "Insert mobile number" }
                                    val={ item.phone }
                                    size="full" 
                                    regExp={/^[+0-9]{9,13}$/}
                                    allowChars={/^[+0-9]{0,13}$/}
                                    minChar={ 1 } 
                                    index={ index } 
                                    forceValidate={ forceValidate }/>
                        </div>
                    </div>
                    <div className="input-row">
                        <div className="col">
                            <Input  id={"email-" + index }
                                    name={"email-" + index }
                                    required={ true }
                                    setFunction={ val => { updateValue(val, index, 'email'); } }
                                    type="text"
                                    // label={ "Email address" }
                                    label={ "Registered email address with UAE Pass" }
                                    placeholder={ "Insert email address" }
                                    val={ item.email }
                                    size="full" 
                                    regExp={/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/}
                                    allowChars={/.*/}
                                    minChar={ 1 } 
                                    index={ index } 
                                    forceValidate={ forceValidate } />
                        </div>
                        <div className="col input-checkbox">
                            {/* <Button title="Add another authorized person"
                                    class={`checkbox-layout`}
                                    size="full"
                                    setFunction={() => {
                                        if (index < authorizedPersons.length -1) {
                                            removeLastFromArray();
                                        } else {
                                            addItemToArray();
                                        }
                                    }}
                            /> */}
                            <Checkbox   required={ false } 
                                    id="additionalAddress"
                                    setFunction={() => {
                                        if (index < authorizedPersons.length -1) {
                                            removeLastFromArray();
                                        } else {
                                            addItemToArray();
                                        }
                                    }}
                                    val={index < authorizedPersons.length -1 ? true : false}
                                    forceValidate={ forceValidate }
                                    text="Add another authorized person" />
                        </div>
                    </div>
                    </>
                )) }
                {/* <div className="input-row inputs-action-item">
                    <div className="col">
                        <Button title="Add another authorized person"
                                add={ true } 
                                class="black reverse"
                                size="full"
                                setFunction={ () => addItemToArray() } />
                    </div>
                    <div className="col">
                        { authorizedPersons.length > 1  &&
                            <Button title="Delete authorized person" 
                                    class="black reverse" 
                                    minus={ true } 
                                    setFunction={ () => removeLastFromArray() } />
                        }
                    </div>
                </div> */}
                <ButtonsNav prev={() => prev()} next={() => next()} />
            </div>
        </div>
    )
}

export default AuthorizedPersons;